import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import { I18nProvider } from './i18n/I18nProvider'
import './index.css'

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <I18nProvider defaultLang={'it'}>
      <App />
    </I18nProvider>
  </HelmetProvider>
);
